<script setup lang="ts">
import { computed } from 'vue';

import { getCssCustomPropertyValue, getStringStyles } from '@libs/ui';

import { useGlobalCurrencyStore } from '../../../stores/globalCurrencyStore';

import {
  decorateWithBrackets,
  calculateRelativePrice,
} from './RelativeMoneyFormatter.helper';
import type { RelativeMoneyFormatterData } from './RelativeMoneyFormatter.model';

interface RelativeMoneyFormatterProps {
  data: RelativeMoneyFormatterData;
}

const props = defineProps<RelativeMoneyFormatterProps>();

const globalCurrencyStore = useGlobalCurrencyStore();

const style = computed(() =>
  getStringStyles(props.data.font, props.data.color, getCssCustomPropertyValue)
);

const value = computed(() => {
  const value = calculateRelativePrice(
    props.data.price,
    props.data.basePrice,
    globalCurrencyStore.formatMoney
  );
  return decorateWithBrackets(value, props.data.bracketType);
});
</script>

<template>
  <span class="relative-money-formatter" :style="style">
    {{ value }}
  </span>
</template>

<style scoped lang="scss">
.relative-money-formatter {
  text-wrap: nowrap;
}
</style>
